module.exports = __webpack_public_path__ + "img/banner_05.62cdaec.gif";